import * as React from 'react';
import { Button, Grid, Icon, IconSize, IconType } from 'ui-toolkit';
import docSvg from '../doc.svg';

interface IFileReview {
  onDeleteClick: () => void;
  onFileNameClick: () => void;
  fileName: string;
}

const FileReview: React.FunctionComponent<IFileReview> = (props) => {
  return (
    <Grid columnCount={3} columnWidth={'min-content'}>
      <Button intent="ghost" isInline>
        <img alt={'doc'} src={docSvg} />
      </Button>
      <Button intent="ghost" isInline onClick={props.onFileNameClick}>
        {props.fileName}
      </Button>
      <Button intent="ghost" isInline onClick={props.onDeleteClick}>
        <Icon type={IconType.Remove} size={IconSize.Small} />
      </Button>
    </Grid>
  );
};

export default FileReview;
